import React, { useEffect } from 'react'
import { getEventsMapByKeyName } from './eventRegistrySingleton'
type Props = {}

const EventHandler = (props: Props) => {

  useEffect(() => {
    const mousemoveEventHandling = (e: MouseEvent) => {
      getEventsMapByKeyName("mousemove")?.forEach(x => x.call({}));

    }
    const mouseClickEventHandling = (e: MouseEvent) => {
      getEventsMapByKeyName("Click")?.forEach(x => x.call({}));

    }
    const keyboardEventHandling = (e: KeyboardEvent) => {
      switch (e.key) {
        case "Escape":
          getEventsMapByKeyName("Escape")?.forEach(x => x.call({}));
          break;
        case "Delete":
          break;
        default:
          break;
      }
    }
    window.addEventListener("mousemove", mousemoveEventHandling);
    window.addEventListener("keydown", keyboardEventHandling);
    window.addEventListener("click", mouseClickEventHandling);
    return () => {
      window.removeEventListener("keydown", keyboardEventHandling)
      window.removeEventListener("click", mouseClickEventHandling)
    }
  }, [])


  return (
    <></>
  )
}

export default EventHandler